import Icon from '../Icon';

const DeleteFromPlanner = (props) => {
  const { color, ...rest } = props;
  const iconColor = color || 'var(--color-i-red)';
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5428 21.0039H8.45698C7.28078 21.0039 6.30288 20.0983 6.21267 18.9256L5.24707 6.3728H18.7527L17.7871 18.9256C17.6969 20.0983 16.719 21.0039 15.5428 21.0039V21.0039Z"
        stroke={iconColor}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0037 6.37277H3.99707"
        stroke={iconColor}
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1865 2.99634H14.8138C15.4354 2.99634 15.9393 3.50023 15.9393 4.12181V6.37274H8.06104V4.12181C8.06104 3.50023 8.56492 2.99634 9.1865 2.99634Z"
        fill="none"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9694 10.8748V16.5021"
        stroke={iconColor}
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0305 10.8748V16.5021"
        stroke={iconColor}
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default DeleteFromPlanner;
